import { render } from "./SaveIcon.vue?vue&type=template&id=39dd68fb"
import script from "./SaveIcon.vue?vue&type=script&lang=js"
export * from "./SaveIcon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__